import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {PaymentCard, ConfirmPayment, Card} from '../components';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {authRequest, txRequest, confirmRequest} from '../store/actions';
import {Spinner} from 'baseui/spinner';
import {useTranslation} from 'react-i18next';
import IconDone from 'baseui/icon/check';
import IconFail from 'baseui/icon/delete';
import * as qs from 'query-string';
const HomeScreen = ({
  loading,
  preloading,
  tx,
  txStatus,
  user,
  stage,
  authRequest,
  confirmRequest,
  txRequest,
  comment,
  cardType,
}) => {
  const [basic, setBasic] = React.useState();
  const {t, i18n} = useTranslation();
  const detectQuery = () => {
    const parsed = qs.parse(window.location.search);
    document.title = t('Payment details');
    setBasic(parsed);
  };
  const redirect = to => {
    if (to == 'done' && basic.redirectSuccess) {
      window.location.href = basic.redirectSuccess;
    }
    if (to == 'fail' && basic.redirectFail) {
      window.location.href = basic.redirectFail;
    }
  };
  useEffect(() => {
    if (txStatus == 'done' || txStatus == 'fail') {
      setTimeout(() => {
        redirect(txStatus);
      }, 3000);
    }
  }, [txStatus]);

  useEffect(() => {
    authRequest();
    detectQuery();
  }, []);
  if (preloading) {
    return (
      <div>
        <Card title={t('Preloading')}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '40px',
            }}>
            <Spinner size={70} />
            <p style={{marginTop: '20px'}}>{t('Preloading')}</p>
          </div>
        </Card>
      </div>
    );
  }
  if (loading) {
    return (
      <div>
        <Card title={t('Transaction processing')}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '40px',
            }}>
            <Spinner size={70} />
            <p style={{marginTop: '20px'}}>{t('Loading')}</p>
          </div>
        </Card>
      </div>
    );
  }

  if (txStatus == 'process') {
    // let stage = 'bankCode';
    // let comment = '+dfsdf';
    // let cardType = 'mastercard';
    return (
      <div>
        <Card
          title={t(stage + 'Title')}
          cardType={stage == 'bankCode' && cardType}
          desc={t(stage + 'Desc')}>
          <ConfirmPayment
            comment={comment}
            stage={stage}
            onConfirm={confirmRequest}
          />
        </Card>
      </div>
    );
  }
  if (txStatus == 'done') {
    return (
      <div>
        <Card title={t('Payment done')}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <IconDone size={57} color="#0775EB" />
          </div>
        </Card>
      </div>
    );
  }

  if (txStatus == 'fail') {
    return (
      <div>
        <Card title={t('Payment failed')} desc={t('Something goes wrong')}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <IconFail size={57} color="#F60000" />
          </div>
        </Card>
      </div>
    );
  }
  if (user && basic) {
    return (
      <div>
        <Card
          title={t('Payment details')}
          desc={t('PayTo', {address: basic.recipient})}>
          <PaymentCard basic={basic} onSend={txRequest} />
        </Card>
      </div>
    );
  }
};

const mapStateToProps = state => {
  const {
    loading,
    user,
    tx,
    cardType,
    stage,
    comment,
    preloading,
    txStatus,
  } = state;
  return {loading, user, stage, tx, cardType, comment, preloading, txStatus};
};
const mapDispatchToProps = dispatch =>
  bindActionCreators({authRequest, txRequest, confirmRequest}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeScreen);
